<!-- <app-loader 
      class="loader" 
      [status$]="status$"
   ></app-loader> -->
<div 
   class="pager-wrapper" 
   [class.invisible]="hideTillFirsLoad( status$ | push )"
   *ngIf="(pager$ | push)"
>
   <span class="arrow prev">
      <a 
       class="pager-link" 
       title="Předchozí strana"
       [routerLink]="['./']" 
       [queryParams]="getQueryParamsPrev(pager$ | push)"
       queryParamsHandling=""
       matRipple
       *ngIf="(firstPage$ | push) !== true"
     >
      <app-icon class="arrow-icon" name="up" [shadow]="true" ></app-icon>
     </a>
   </span>
   <span class="page-label" [class.invisible]="((pager$ | push).lastPage < 2) || ( status$ | push ) === 'pending'" >
      Strana {{(currentPage$ | push)}}
   </span>   
   <span class="arrow next">
      <a 
       class="pager-link" 
       title="Následující strana" 
       [routerLink]="['./']" 
       [queryParams]="getQueryParamsNext(pager$ | push)"
       queryParamsHandling=""
       matRipple
       *ngIf="(lastPage$ | push) !== true"
      >
      <app-icon class="arrow-icon" name="up" [shadow]="true" ></app-icon>
     </a>
   </span>
   
</div>
  
  
